import React, { useContext } from 'react';
import { FirebaseContext } from '../Firebase'

import { StreamApp, Streami18n } from 'react-activity-feed';
import Loading from '../Loading'
import { useRouter } from 'next/router'

import Dayjs from 'dayjs';

import 'dayjs/locale/en'
import 'dayjs/locale/de'


const StreamAppComponent = ({children, showLoading = true}) => {
    const apiKey = process.env.NEXT_PUBLIC_STREAM_API
    const appId = process.env.NEXT_PUBLIC_STREAM_APP_ID
    
    // default read-only token generated via streamSigner.JWTScopeToken(apiSecret, 'feed', 'read', {'feedId': '*', userId: "global"})
    const readOnlyToken = process.env.NEXT_PUBLIC_STREAM_READONLY_TOKEN
    const auth = useContext(FirebaseContext)
    const { user, streamUserToken } = auth
    const router = useRouter()

    const i18n = new Streami18n({ language: 'en',  dayjsLocaleConfigForLanguage:{Dayjs} })

    i18n.registerTranslation('de', {
        "Load more": "Mehr laden",
        "No data to display...": "Ist noch leer...",
        "You have 1 new notification": "Du hast 1 neue Benachrichtigung",
        "You have {{ notificationCount }} new notifications": "Du hast {{ notificationCount }} neue Benachrichtigungen",
        "{{ actorName }} and 1 other followed you": "{{ actorName }} und 1 weiteren Person haben dich gefolgt",
        "{{ actorName }} and 1 other liked your {{ activityVerb }}": "{{ actorName }} und 1 weiteren Person gefällt dein {{ activityVerb }}",
        "{{ actorName }} and {{ countOtherActors }} others followed you": "{{ actorName }} und {{ countOtherActors }} weitere Personen folgen dir",
        "{{ actorName }} and {{ countOtherActors }} others liked your {{ activityVerb }}": "{{ actorName }} und {{ countOtherActors }} weiteren Personen gefällt dein {{ activityVerb }}",
        "{{ actorName }} followed you": "{{ actorName }} folgt dir",
        "{{ actorName }} liked your {{ activityVerb }}": "{{ actorName }} gefällt dein {{ activityVerb }}",
      });

    i18n.setLanguage(router.locale)

    if(user === null) return <div>{showLoading && <Loading minHeightScreen/>}</div>

    let token
    if(user === false || user.isAnonymous) {
        token = readOnlyToken
    } else if (streamUserToken) {
        token = streamUserToken
    }

    return (
      <>
        {token ? (
          <StreamApp
            apiKey={apiKey}
            appId={appId}
            token={token}
            i18nInstance={i18n}
          >
            {children}
          </StreamApp>
        ) : 
          showLoading && <Loading minHeightScreen />
        }
      </>
    )
};


export default StreamAppComponent; 